import { render, staticRenderFns } from "./step.vue?vue&type=template&id=b71ff1a4&scoped=true"
import script from "./step.vue?vue&type=script&lang=js"
export * from "./step.vue?vue&type=script&lang=js"
import style0 from "./step.vue?vue&type=style&index=0&id=b71ff1a4&prod&lang=less"
import style1 from "./step.vue?vue&type=style&index=1&id=b71ff1a4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b71ff1a4",
  null
  
)

export default component.exports